export const URL = process.env.NODE_ENV === 'development' ? 'http://localhost:8080' : 'https://technology.medignition.com';

export const API_URL =
  process.env.NODE_ENV === 'development' ? 'http://localhost:8080/api' : 'https://technology.medignition.com/api';

export const APPLICATION_TOKEN = 'FD53B78B21C82CE6B1C2536AA458A3CCBBBE5AA575D2324C947B717F64E9C788';
